/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable implicit-arrow-linebreak */
import { ReactElement, useState, useEffect, useRef } from 'react';
import { Routes, Route, useNavigate, useParams, useLocation, useRoutes, Outlet } from 'react-router-dom';
import { Formik, Form, FormikProps, getIn } from 'formik';
import { defaultForm, getReceiptPayload, getSubmissionPayload, iFVSFormValues, FVSSchema, FVSMetaData } from '@services/FVSService';
import { FormContainer } from '@pages';
import ReactGA from 'react-ga';
import { FormNavFooter, FormLoading, Alert, ProgressBar } from '@components';
import { FormType } from '@constants';
import { iToolTips, iCountry, iFormNavActions, iApiError, iPartialFormData, iFVSCheckboxAll } from '@interfaces/interfaces';
import {
  getCountryList,
  getBasicInfo,
  getTooltips,
  savePartialForm,
  getPartialForm,
  getPaymentArrangement,
  getObligationOptions,
  getEligibleNominationList,
  submitSavedPartialForm,
} from '@api';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';
import { navigateToError, navigateToNextStep, getStringIndex, setFormDataValues, setCurrentFormikValues, getDateForValidateDebtor, navToError } from '@utils';
import ErrorContent from '@components/Content/AlertContent/ErrorContent';
import {
  FVSStep0,
  FVSStep1,
  FVSStep2,
  FVSStep3,
  FVSStep4,
  FVSStep5,
  FVSStep6,
  FVSStep7,
  FVSStep8,
  FVSStep9,
  FVSStep10,
  FVSStep11,
  FVSStep12,
  FVSStep13,
  FVSStep14,
  FVSStep15,
  FVSStep16,
  FVSStep17,
  FVSStep18,
  FVSStep19,
  FVSStep20,
  FVSStep21,
  FVSStep22,
  FVSStep23,
  FVSStep24,
  FVSStep25,
  FVSErrorPage
} from '.';
import VicFinesContext from '../VicFinesFormContext';
import IssueIcon from '../../../images/issue.svg';

const { REACT_APP_SITECORE_API_ENDPOINT: API_URL, REACT_APP_PATH_FAMILY_VIOLENCE_SCHEME: PATH_FVS } = process.env;

function FamilyViolenceScheme(): ReactElement {
  const location = useLocation();
  const navigate = useNavigate();
  const pathElementArray = location.pathname.split('/');
  const stepIndex = getStringIndex(pathElementArray, 'step');
  const stepIndexDiff = stepIndex - pathElementArray.length;
  // example returned [step0,3224242] or [step0]
  const stepArray = pathElementArray.slice(stepIndexDiff);
  // example returned 0
  const stepIndexInPath = getStringIndex(stepArray, 'step');
  // always get the element contain step like step0
  const getStepInPath = stepArray[stepIndexInPath];
  const pathNameLessLastSegment = stepIndex ? location.pathname.split('/').slice(0, stepIndexDiff).join('/') : location.pathname;
  const pathNameUpperCase = location.pathname.toLowerCase();
  const currentStep = pathNameUpperCase === `${PATH_FVS}` || pathNameUpperCase === `${PATH_FVS}/` ? 'step0' : `${getStepInPath}`;
  const [loading, setLoading] = useState(true);
  const [countryList, setCountryList] = useState<iCountry[]>([]);
  const [tooltips, setTooltips] = useState<iToolTips>({} as iToolTips);
  const [apiError, setApiError] = useState<iApiError>({} as iApiError);
  const formikValuesRef = useRef({} as FormikProps<iFVSFormValues>);
  const [activeError, setActiveError] = useState(false);
  const partialFormAttachmentFields = ['SelectedObligationsStep9', 'SupportingAttachments', 'SignedDeclarationAttachment', 'OtherSupportingAttachments'];
  const arrayFieldsToBeCleared = [
    'ActionsTakenOnFine',
    'obligations',
    'infringementFineArray',
    'enteredObligationsArray',
    'InfringementNums',
    'AgencyNames',
    'AOffence',
    'DAOffence',
  ];
  type obligationNum = {
    ob: string;
  };
  const redirectUrl = (event: any) => {
    if (event.code === 'Escape') {
      setTimeout(() => {
        window.location.replace('https://www.google.com/');
      });
    }
  };

  const fetchRegObligationNums = (selectedObligations: iFVSCheckboxAll[], authorisedObligation: string) => [
    authorisedObligation,
    ...selectedObligations.filter((e: iFVSCheckboxAll) => e.checked).map(({ number }: { number: string }) => number),
  ];
  const { ob } = useParams<obligationNum>();
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        const [countryResults, tooltipResults] = await Promise.all([getCountryList(), getTooltips('fines.FvsForm')]);
        setCountryList(countryResults);
        setTooltips(tooltipResults);
        setLoading(false);
      } catch (error) {
        navigateToError();
      }
    };
    fetchData();
    const handlePopstate = () => {
      // Check if the back button is clicked
        const isSubmitted = formikValuesRef.current && formikValuesRef.current.values ? formikValuesRef.current.values?.submitted : false;

        if (window.location.pathname === '/fvs-form/step24' || isSubmitted) {
          navigate({
            pathname: '/fvs-form/step25',
            search: location.search,
          });
        }
        if ((window.location.pathname === '/fvs-form/step2') && !isSubmitted) {
          navigate({
            pathname: '/fvs-form/step3',
            search: location.search,
          });
        }
        if ((window.location.pathname === '/fvs-form/error') && !isSubmitted) {
          navigate({
            pathname: '/fvs-form/error',
            search: location.search,
          });
        }
        if ((window.location.pathname === '/fvs-form/step1') && !isSubmitted && formikValuesRef && formikValuesRef.current) {
          formikValuesRef.current.setFieldValue('OBLIGATION_NUMBER', '');
          formikValuesRef.current.setFieldTouched('OBLIGATION_NUMBER');
          formikValuesRef.current.setFieldValue('OFFENCE_DATE', '');
          formikValuesRef.current.setFieldValue('HEARING_DATE', '');
          formikValuesRef.current.setFieldValue('DRIVER_LICENCE', '');
          formikValuesRef.current.setFieldValue('VEHICLE_REGISTRATION', '');
          formikValuesRef.current.setFieldValue('DOB', '');
        }
      };
    window.addEventListener('popstate', handlePopstate);
    document.addEventListener('keyup', redirectUrl);
    return () => {
      window.removeEventListener('popstate', handlePopstate);
      document.removeEventListener('keydown', redirectUrl);
    };
  }, []);

  const displayErrorsCount = (errorCount: number, touchedFields: number): void => {
    if (touchedFields === 0) {
      setActiveError(true);
    } else if (errorCount > 0) {
      setActiveError(true);
    } else {
      setActiveError(false);
    }
  };

  const clearApiError = () => {
    setApiError({
      Error: '',
    });
  };

  const postObligation = async (formikContext: any): Promise<void> => {
    setLoading(true);
    // remove whitespaces before and after obligation number
    const trimmedObligationNumber = formikContext.values.OBLIGATION_NUMBER.trim();
    formikValuesRef.current.setFieldValue('OBLIGATION_NUMBER', trimmedObligationNumber);
    const payload = {
      obligationNumber: trimmedObligationNumber,
    };
    const url = `${API_URL}sitecore/FVS/ValidateObligation`;
    let response: any;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const responseBody = await response.json();
      setLoading(false);
      if (response.status === 400 && responseBody.Error) {
        setApiError(responseBody);
        return;
      }
      if (response.status === 422 && responseBody.Error) {
        setApiError(responseBody);
        return;
      }
      if (response.status === 200) {
        const nextPageUrl = `${pathNameLessLastSegment}${responseBody.NextStep}`;
        if (responseBody.obligationNumber) {
          formikValuesRef.current.setFieldValue('OBLIGATION_NUMBER', responseBody.obligationNumber);
        }
        setApiError({
          Error: '',
        });
        navigate(nextPageUrl);
        window.scrollTo(0, 0);
        return;
      }
      navigateToError();
    } catch (error) {
      navigateToError();
    }
  };
  const resetPFormDataValues = (partialFormApi: any, formikObject: any) => {
    if (partialFormApi && formikObject) {
      // clone data format like objectkey: [{},{}]
      if (
        Array.isArray(partialFormApi) &&
        partialFormApi[0] &&
        typeof partialFormApi[0] === 'object' &&
        Array.isArray(formikObject) &&
        (formikObject.length !== partialFormApi.length || partialFormApi.length === 0)
      ) {
        partialFormApi.forEach((val) => {
          type dynamicObj = {
            [key: string]: string;
          };
          const temp = {} as dynamicObj;
          Object.keys(val).forEach((key) => {
            temp[key] = val[key];
          });
          formikObject.push(temp);
        });
      }
      // handle scenario if formikObject is empty array , it's for ObjectKey:[] or string[]
      if (
        Array.isArray(partialFormApi) &&
        partialFormApi[0] &&
        typeof partialFormApi[0] === 'string' &&
        Array.isArray(formikObject) &&
        (formikObject.length !== partialFormApi.length || partialFormApi.length === 0)
      ) {
        partialFormApi.forEach((val) => {
          formikObject.push(val);
        });
      }
      if (partialFormApi && formikObject) {
        Object.keys(partialFormApi).forEach((key) => {
          if (key in formikObject) {
            if (typeof partialFormApi[key] === 'object' && !(partialFormApi[key] instanceof Date)) {
              if (partialFormAttachmentFields.includes(key) || arrayFieldsToBeCleared.includes(key)) {
                formikObject[key] = [];
              }
              resetPFormDataValues(partialFormApi[key], formikObject[key]);
            } else {
              formikObject[key] = partialFormApi[key];
            }
          }
        });
      }
    }
  };
  const checkIfAnyChanges = (partialFormApi: any, formikObject: any): boolean => {
    if (!(formikObject && partialFormApi)) {
      return false;
    }
    let isChanged = false;
    Object.keys(formikObject).forEach((key) => {
      if (key in partialFormApi) {
        if (typeof partialFormApi[key] === 'object' && partialFormApi[key] && !(partialFormApi[key] instanceof Date)) {
          if (Array.isArray(partialFormApi[key])) {
            if (partialFormApi[key].length !== formikObject[key].length) {
              isChanged = true;
            }
          }
          checkIfAnyChanges(partialFormApi[key], formikObject[key]);
        } else if (key === 'DOB' && partialFormApi[key] && partialFormApi[key]?.getTime() !== formikObject[key]?.getTime?.()) {
          isChanged = true;
        } else if (partialFormApi[key] && partialFormApi[key] !== formikObject[key]) {
          isChanged = true;
        }
      }
    });
    return isChanged;
  };
  const checkExistingForm = async (formikContext: any): Promise<void> => {
    setLoading(true);
    const payload = {
      ObligationNO: formikContext.values.OBLIGATION_NUMBER,
      formType: FormType.FAMILYVIOLENCESCHEME,
    };
    const url = `${API_URL}sitecore/PartialForms/CheckingExistingForm`;

    let response: any;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const responseBody = await response.json();
      if (response.status === 200) {
        if (responseBody.PartialFormID) formikValuesRef.current.setFieldValue('PartialFormID', responseBody.PartialFormID);
        if (responseBody.DebtorID) formikValuesRef.current.setFieldValue('DebtorID', responseBody.DebtorID, formikContext);
        if (responseBody.CheckingExisting === 'no' && responseBody.CanSave) {
          setLoading(false);
          navigate(`${pathNameLessLastSegment}/step4`);
          window.scrollTo(0, 0);
          return;
        }
        if (responseBody.PartialFormID) {
          getPartialForm(responseBody.PartialFormID)
            .then((resBody) => {
              if (typeof resBody === 'string') {
                if (resBody === 'Unauthorised') {
                  navigateToError();
                }
              } else {
                const formData = JSON.parse(resBody.FormData);
                const keys = Object.keys(resBody);
                keys.forEach((key) => {
                  if (key === 'FormData') {
                    setFormDataValues(formData, formikValuesRef.current.values.FormData, formikValuesRef, 'FormData');
                    setCurrentFormikValues(formData, formikValuesRef.current.values, formikValuesRef);
                  } else if (resBody[key]) {
                    formikContext.setFieldValue(`${key}`, resBody[key]);
                  }
                });
              }
              setLoading(false);
            })
            .catch((e) => console.log(e));
        } else {
          setLoading(false);
        }
        navigate(`${pathNameLessLastSegment}/step5`);
        window.scrollTo(0, 0);
      }
    } catch (error) {
      navigateToError();
    }
  };

  const step2NextPage = () => {
    navigateToNextStep(navigate, location, 'next');
  };
  const validateDebtor = async (formikContext: any): Promise<void> => {
    setLoading(true);
    // Backend api is checking date time for some reasons, time need to be 14:00:00
    const getOffenceDate = formikContext.values.OFFENCE_DATE && getDateForValidateDebtor(formikContext.values.OFFENCE_DATE.toLocaleDateString('en-AU'));
    const getHearingDate = formikContext.values.HEARING_DATE && getDateForValidateDebtor(formikContext.values.HEARING_DATE.toLocaleDateString('en-AU'));
    const getDOBDate = formikContext.values.DOB && getDateForValidateDebtor(formikContext.values.DOB.toLocaleDateString('en-AU'));
    // const dateObj = getTheDate.split('/');
    // const specificedDateString = `${dateObj[2]}-${dateObj[1]}-${dateObj[0]}`;
    const payload = {
      dateOfBirth: getDOBDate,
      hearingDate: getHearingDate,
      licenceNumber: formikContext.values.DRIVER_LICENCE,
      obligationNumber: formikContext.values.OBLIGATION_NUMBER,
      offenceDate: getOffenceDate,
      registrationNumber: formikContext.values.VEHICLE_REGISTRATION,
    };
    const url = `${API_URL}sitecore/FVS/ValidateDebtor`;
    let response: any;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const responseBody = await response.json();
      setLoading(false);
      if (response.status === 400 && responseBody.Error) {
        setApiError(responseBody);
        return;
      }
      if (response.status === 200) {
        setApiError({
          Error: '',
        });
        if (responseBody === '/step4') {
          step2NextPage();
        }
      }
    } catch (error) {
      navigateToError();
    }
  };
  const step3NextPage = (formikContext: any) => {
    getBasicInfo(formikContext.values.OBLIGATION_NUMBER, FormType.FAMILYVIOLENCESCHEME)
      .then((responseBody) => {
        if (responseBody) {
          formikContext.setFieldValue('ObligationStatus', responseBody.ObligationStatus);
          formikContext.setFieldValue('TicketType', responseBody.TicketType);
          formikContext.setFieldValue('Status', responseBody.Status);
          formikContext.setFieldValue('DebtorType', responseBody.DebtorType);
          formikContext.setFieldValue('OffenceCode', responseBody.OffenceCode);
        }
      })
      .catch((e) => console.log(e));
    checkExistingForm(formikContext);
  };
  const updatePartialFormData = async (formikContext: any): Promise<boolean> => {
    const { values } = formikContext;
    resetPFormDataValues(values, formikContext.values.FormData);
    const partialformPayload: iPartialFormData = {
      ID: formikContext.values.PartialFormID,
      Obligations: formikContext.values.Obligations,
      Attachments: [],
      FormData: JSON.stringify(formikContext.values.FormData), // {a: '1'},formikContext.values.FormData
      DebtorID: formikContext.values.DebtorID,
      FormTypeID: 7,
      Email: formikContext.values.saveEmail,
      Mobile: formikContext.values.saveMobile,
      IsSubscribedEM: formikContext.values.IsSubscribedEM,
      IsSubscribedSMS: formikContext.values.IsSubscribedSMS,
      EMRemeinderSent: formikContext.values.EMRemeinderSent,
      SMSRemeinderSent: formikContext.values.SMSRemeinderSent,
      CreateDate: formikContext.values.CreateDate,
      ExpiryDate: formikContext.values.ExpiryDate,
    };
    try {
      const response = await savePartialForm(partialformPayload);
      return response;
    } catch (error) {
      console.log(error);
      return false;
    }
  };
  const step5NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    if (formikContext.values.ApplicationLodger === 'LodgedByVictim') {
      navigate(`${pathNameLessLastSegment}/step6`);
      window.scrollTo(0, 0);
    } else {
      navigate(`${pathNameLessLastSegment}/step14`);
      window.scrollTo(0, 0);
    }
  };
  const step6NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    const {
      noFixedAddress,
      noResidentialAddress,
      deliveryAddressType,
      postalAddress,
      noPostalAddress,
      isEmailRequired,
      email,
      sendEmailCopy,
      phoneApplicant,
      individualContactNumber,
      safestContactTime,
      phoneMessagePrompt,
      interpreterRequiredPrompt,
      alternativeLanguage,
    } = fvsInfoDisplayObject.pages.contactInformation.step6.fields;
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    /* Condition 1 */
    if (getIn(formikContext.values, noFixedAddress.formikName) || getIn(formikContext.values, noResidentialAddress.formikName)) {
      formikContext.setFieldValue(deliveryAddressType.formikName, '');
      formikContext.setFieldTouched(deliveryAddressType.formikName);
    }
    /* Condition 2 */
    if (
      !getIn(formikContext.values, noFixedAddress.formikName) &&
      !getIn(formikContext.values, noResidentialAddress.formikName) &&
      getIn(formikContext.values, deliveryAddressType.formikName) !== 'PostalAddress'
    ) {
      formikContext.setFieldValue(postalAddress.formikName, {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      });
      formikContext.setFieldTouched(postalAddress.formikName);
    }
    /* Condition 3 */
    if (!getIn(formikContext.values, noFixedAddress.formikName) && !getIn(formikContext.values, noResidentialAddress.formikName)) {
      formikContext.setFieldValue(noPostalAddress.formikName, false);
      formikContext.setFieldTouched(noPostalAddress.formikName);
    }
    /* Condition 4 */
    if (
      !getIn(formikContext.values, noFixedAddress.formikName) &&
      !getIn(formikContext.values, noResidentialAddress.formikName) &&
      getIn(formikContext.values, deliveryAddressType.formikName) === 'EmailAddress'
    ) {
      formikContext.setFieldValue(isEmailRequired.formikName, null);
      formikContext.setFieldTouched(isEmailRequired.formikName);
    }
    /* Condition 5 */
    if (getIn(formikContext.values, isEmailRequired.formikName) === 'false') {
      formikContext.setFieldValue(email.formikName, '');
      formikContext.setFieldValue(sendEmailCopy.formikName, null);
      formikContext.setFieldTouched(email.formikName);
      formikContext.setFieldTouched(sendEmailCopy.formikName);
    }
    /* Condition 6 */
    if (getIn(formikContext.values, phoneApplicant.formikName) === 'false') {
      formikContext.setFieldValue(individualContactNumber.formikName, {
        ContactNumber: '',
        NumberType: 'Mobile',
        SecondaryContactNumber: '',
        SecondaryNumberType: 'Mobile',
      });
      formikContext.setFieldValue(safestContactTime.formikName, '');
      formikContext.setFieldValue(phoneMessagePrompt.formikName, null);
      formikContext.setFieldValue(interpreterRequiredPrompt.formikName, null);
      formikContext.setFieldTouched(individualContactNumber.formikName);
      formikContext.setFieldTouched(safestContactTime.formikName);
      formikContext.setFieldTouched(phoneMessagePrompt.formikName);
      formikContext.setFieldTouched(interpreterRequiredPrompt.formikName);
      formikContext.setFieldValue(alternativeLanguage.formikName, '');
      formikContext.setFieldTouched(alternativeLanguage.formikName);
    }
    /* Condition 7 */
    if (getIn(formikContext.values, interpreterRequiredPrompt.formikName) === 'false') {
      formikContext.setFieldValue(alternativeLanguage.formikName, '');
      formikContext.setFieldTouched(alternativeLanguage.formikName);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step7NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step8NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step9NextPage = async (formikContext: any) => {
    window.scrollTo(0, 0);
    if (formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    setLoading(true);
    const payload = fetchRegObligationNums(formikContext.values.SelectedObligationsStep9, formikContext.values.AuthorisedObligation.Number);
    await formikContext.setFieldValue('SelectedObligations', payload);
    try {
      if (payload) {
        const response = await getEligibleNominationList(payload, 'FVS');
        setLoading(false);
        if (response) {
          await formikContext.setFieldValue('AnyEligibleNomiation', response.anyEligibleNomiation);
          if (response.anyEligibleNomiation || (formikContext.values.AgencyNames.length >= 1 && formikContext.values.AgencyNames[0].value !== '')) {
            navigateToNextStep(navigate, location, 'next');
            return;
          }
        }
      }
      formikContext.setFieldValue('WhatWouldYouLikeToHappen', null);
      formikContext.setFieldValue('GivenNamesOptional', '');
      formikContext.setFieldValue('FamilyNameOptional', '');
      formikContext.setFieldValue('DOBOptional', null);
      formikContext.setFieldValue('LicenceStateOptional', '');
      formikContext.setFieldValue('StatecountryOfIssueOptional', 'Australia');
      formikContext.setFieldValue('HowDealtWithFines', '');
      formikContext.setFieldValue('RemoveFines', null);
      formikContext.setFieldValue('ReincludeFines', null);
      navigate(`${pathNameLessLastSegment}/step12`);
      window.scrollTo(0, 0);
    } catch (error) {
      navigateToError();
    }
  };

  const step10NextPage = async (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    const payload =
      fetchRegObligationNums(formikContext.values.SelectedObligationsStep9, formikContext.values.AuthorisedObligation.Number).length !== 0
        ? fetchRegObligationNums(formikContext.values.SelectedObligationsStep9, formikContext.values.AuthorisedObligation.Number)
        : [];
    setLoading(true);
    try {
      if (payload) {
        const response = await getPaymentArrangement(payload, 'FVS');
        setLoading(false);
        if (response) {
          formikContext.setFieldValue('AnyPaymentArrangement', response.anyPaymentArrangement);
          if (response.anyPaymentArrangement) {
            navigateToNextStep(navigate, location, 'next');
            return;
          }
        }
      }
      navigate(`${pathNameLessLastSegment}/step12`);
      window.scrollTo(0, 0);
    } catch (error) {
      navigateToError();
    }
  };

  const step11NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step12NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step13NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigate(`${pathNameLessLastSegment}/step23`);
    window.scrollTo(0, 0);
  };

  const step14NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step15NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    const {
      email,
      isEmailRequired,
      deliveryAddressType,
      postalAddress,
      phoneApplicant,
      individualContactNumber,
      safestContactTime,
      phoneMessagePrompt,
      interpreterRequiredPrompt,
      alternativeLanguage,
    } = fvsInfoDisplayObject.pages.contactInformation.step15.fields;
    // Change to Review Step later
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    /* Condition 1 */
    if (getIn(formikContext.values, deliveryAddressType.formikName) !== 'PostalAddress') {
      formikContext.setFieldValue(postalAddress.formikName, {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      });
      formikContext.setFieldTouched(postalAddress.formikName);
    }
    /* Condition 2 */
    if (getIn(formikContext.values, isEmailRequired.formikName) === 'false') {
      formikContext.setFieldValue(email.formikName, '');
      formikContext.setFieldTouched(email.formikName);
    }
    /* Condition 3 */
    if (getIn(formikContext.values, phoneApplicant.formikName) === 'false') {
      formikContext.setFieldValue(individualContactNumber.formikName, {
        ContactNumber: '',
        NumberType: 'Mobile',
        SecondaryContactNumber: '',
        SecondaryNumberType: 'Mobile',
      });
      formikContext.setFieldValue(safestContactTime.formikName, '');
      formikContext.setFieldValue(phoneMessagePrompt.formikName, null);
      formikContext.setFieldValue(interpreterRequiredPrompt.formikName, null);
      formikContext.setFieldTouched(individualContactNumber.formikName);
      formikContext.setFieldTouched(safestContactTime.formikName);
      formikContext.setFieldTouched(phoneMessagePrompt.formikName);
      formikContext.setFieldTouched(interpreterRequiredPrompt.formikName);
      formikContext.setFieldValue(alternativeLanguage.formikName, '');
      formikContext.setFieldTouched(alternativeLanguage.formikName);
    }
    /* Condition 4 */
    if (getIn(formikContext.values, interpreterRequiredPrompt.formikName) === 'false') {
      formikContext.setFieldValue(alternativeLanguage.formikName, '');
      formikContext.setFieldTouched(alternativeLanguage.formikName);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step16NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step17NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step18NextPage = async (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    if (getIn(formikContext.values, 'RegisteredFinesToInclude') !== 'true') {
      formikContext.setFieldValue('AdditionalFinesType', '');
      formikContext.setFieldTouched('AdditionalFinesType');
    }
    const payload = [formikContext.values.OBLIGATION_NUMBER];
    setLoading(true);
    try {
      getObligationOptions(formikContext.values.OBLIGATION_NUMBER, FormType.FAMILYVIOLENCESCHEME)
        .then((responseBody) => {
          if (responseBody && responseBody?.Authorised) {
            formikContext.setFieldValue('InfringementNoticeNumber', responseBody?.Authorised.InfringementNumber);
          }
        })
        .catch((e) => console.log(e));
      if (Array.isArray(payload) && payload.length !== 0) {
        const response = await getEligibleNominationList(payload, 'FVS');
        setLoading(false);
        if (response) {
          await formikContext.setFieldValue('AnyEligibleNomiation', response.anyEligibleNomiation);
          if (
            response.anyEligibleNomiation ||
            (formikContext.values.obligations.length >= 1 && formikContext.values.obligations[0].value !== '') ||
            (formikContext.values.AgencyNames.length >= 1 && formikContext.values.AgencyNames[0].value !== '')
          ) {
            navigateToNextStep(navigate, location, 'next');
            return;
          }
        }
      }
      /* Condition for Steps 19 */
      formikContext.setFieldValue('WhatWouldYouLikeToHappen', null);
      formikContext.setFieldValue('GivenNamesOptional', '');
      formikContext.setFieldValue('FamilyNameOptional', '');
      formikContext.setFieldValue('DOBOptional', null);
      formikContext.setFieldValue('LicenceStateOptional', '');
      formikContext.setFieldValue('StatecountryOfIssueOptional', 'Australia');
      formikContext.setFieldValue('HowDealtWithFines', '');
      navigate(`${pathNameLessLastSegment}/step20`);
      window.scrollTo(0, 0);
    } catch (error) {
      navigateToError();
    }
  };

  const step19NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step20NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (checkIfAnyChanges(formikContext.values, formikContext.values.FormData) && formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step21NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };

  const step22NextPage = (formikContext: any) => {
    window.scrollTo(0, 0);
    if (formikContext.values.SaveYesNo === 'true') {
      updatePartialFormData(formikContext);
    }
    navigateToNextStep(navigate, location, 'next');
  };
  const createPartialForm = async (formikContext: any): Promise<void> => {
    if (formikContext.values.SaveYesNo === 'false' || getIn(formikContext.values, 'PartialFormID')) {
      navigateToNextStep(navigate, location, 'next');
      return;
    }
    setLoading(true);
    const { values } = formikContext;
    resetPFormDataValues(values, formikContext.values.FormData);
    const payload = {
      Attachments: '',
      CreateDate: '',
      DebtorID: `${formikContext.values.DebtorID}`,
      EMRemeinderSent: false,
      Email: formikContext.values.saveEmail,
      ExpiryDate: '',
      FormData: JSON.stringify({ a: '1', ...formikContext.values.FormData }),
      FormTypeID: 7,
      ID: 0,
      IsSubscribedEM: !!formikContext.values.saveEmail,
      IsSubscribedSMS: !!formikContext.values.saveMobile,
      Mobile: formikContext.values.saveMobile,
      Obligations: [
        {
          ID: 0,
          ObligationNO: formikContext.values.OBLIGATION_NUMBER,
          IsPrimary: true,
        },
      ],
      SMSRemeinderSent: false,
    };
    const url = `${API_URL}sitecore/PartialForms/CreatePartialForm`;
    let response: any;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const responseBody = await response.json();
      setLoading(false);
      if (response.status === 200) {
        if (responseBody.ID) {
          formikValuesRef.current.setFieldValue('PartialFormID', responseBody.ID);
          formikValuesRef.current.setFieldValue('Obligations', responseBody.Obligations);
        }
        navigateToNextStep(navigate, location, 'next');
        return;
      }
      navigateToError();
    } catch (error) {
      console.log(error);
    }
  };
  const createPartialFormForSumbit = async (formValues: iFVSFormValues): Promise<string> => {
    formikValuesRef.current.setFieldValue('SaveYesNo', 'true');
    resetPFormDataValues(formikValuesRef.current.values, formValues.FormData);
    const payload = {
      Attachments: '',
      CreateDate: '',
      DebtorID: `${formValues.DebtorID}`,
      EMRemeinderSent: false,
      Email: '',
      ExpiryDate: '',
      FormData: JSON.stringify({ ...getIn(formValues, 'FormData') }),
      FormTypeID: 7,
      ID: 0,
      IsSubscribedEM: false,
      IsSubscribedSMS: false,
      Mobile: '',
      Obligations: [
        {
          ID: 0,
          ObligationNO: formValues.OBLIGATION_NUMBER,
          IsPrimary: true,
        },
      ],
      SMSRemeinderSent: false,
    };
    const url = `${API_URL}sitecore/PartialForms/CreatePartialForm`;
    let response: any;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const responseBody = await response.json();
      if (responseBody.status === 200) {
          return 'true';
      }
      return responseBody;
    } catch (error) {
      return `${error}`;
    }
  };
  const submitForm = async (formValues: iFVSFormValues): Promise<boolean> => {
    /*
    const receiptPayload = getReceiptPayload(formValues);
    const urlReceipt = `${API_URL}sitecore/Receipt/CreateReceiptNumber`;
    let receiptResponse: any;
    try {
      receiptResponse = await fetch(urlReceipt, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: receiptPayload,
      });
    } catch (error) {
      return false;
    }

    if (receiptResponse.status !== 200) {
      return false;
    }

    const submissionNumber = await receiptResponse.text();
    */
    const submissionNumber = '';
    const formSubmissionValues = getSubmissionPayload(formValues, submissionNumber);
    console.log(formSubmissionValues);
    const submitPayload = {
      data: JSON.stringify(formSubmissionValues),
      obligationNo: formValues.OBLIGATION_NUMBER
    };

    const urlSubmission = `${API_URL}sitecore/FVS/SubmitFvsForm`;
    let submitResponse = false;
      setLoading(true);
      submitResponse = await fetch(urlSubmission, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submitPayload),
      })
      .then((formSubResponse) => {
        if (formSubResponse.status === 200) {
          if (formValues.SaveYesNo === 'true') {
            // having partial form, close it
            submitSavedPartialForm(formValues.PartialFormID);
          }
          formikValuesRef.current.setFieldValue('submitted', true);
          ReactGA.event({
            category: 'Family Violence Scheme Form',
            action: 'Submit',
            label: 'Submit Family Violence Scheme Form',
          });
          // navigate to submission success
          return formSubResponse.json();
        }
        formikValuesRef.current.setFieldValue('submissionError', formSubResponse.statusText);
        if (formValues.SaveYesNo === 'false') {
          createPartialFormForSumbit(formValues);
        }
        navToError(navigate, location);
        return false;
      }).then((response) => {
        if (response) {
          formikValuesRef.current.setFieldValue('submissionNo', response.receiptNo); // get submission number from API response
          return true;
        }
        return false;
      }).catch((error) => {
        formikValuesRef.current.setFieldValue('submissionError', error);
        if (formValues.SaveYesNo === 'false') {
          createPartialFormForSumbit(formValues);
        }
        navToError(navigate, location);
        return false;
      })
      .finally(() => {
        setLoading(false);
      });
      if (!submitResponse) return false;
      return true;
  };

  const formNavActions: iFormNavActions = {
    step1: {
      next: postObligation,
    },
    step2: {
      next: validateDebtor,
    },
    step3: {
      next: step3NextPage,
    },
    step4: {
      next: createPartialForm,
    },
    step5: {
      next: step5NextPage,
    },
    step6: {
      next: step6NextPage,
    },
    step7: {
      next: step7NextPage,
    },
    step8: {
      next: step8NextPage,
    },
    step9: {
      next: step9NextPage,
    },
    step10: {
      next: step10NextPage,
    },
    step11: {
      next: step11NextPage,
    },
    step12: {
      next: step12NextPage,
    },
    step13: {
      next: step13NextPage,
    },
    step14: {
      next: step14NextPage,
    },
    step15: {
      next: step15NextPage,
    },
    step16: {
      next: step16NextPage,
    },
    step17: {
      next: step17NextPage,
    },
    step18: {
      next: step18NextPage,
    },
    step19: {
      next: step19NextPage,
    },
    step20: {
      next: step20NextPage,
    },
    step21: {
      next: step21NextPage,
    },
    step22: {
      next: step22NextPage,
    },
  };

  return (
    <Formik
      initialValues={defaultForm()}
      innerRef={formikValuesRef}
      validationSchema={FVSSchema}
      onSubmit={(values: iFVSFormValues) => {
        submitForm(values);
      }}>
      {({ values, errors, touched }) => (
        <VicFinesContext.Provider value={{ countryList, setCountryList, tooltips, setTooltips, apiError, clearApiError }}>
          <FormContainer title="Family Violence Scheme">
            {loading && <FormLoading />}
            {!loading && (
              <Form>
                {!location.pathname.includes('error') && <ProgressBar formMetaData={FVSMetaData} />}
                {activeError && <Alert title="Sorry there is a problem" icon={IssueIcon} color="red" message={<ErrorContent />} theme="error" />}
                <Routes>
                  <Route path="/step0/:ob" element={<FVSStep0 formikRef={formikValuesRef} />} />
                  <Route path="/step1" element={<FVSStep1 />} />
                  <Route path="/step2" element={<FVSStep2 />} />
                  <Route path="/step3" element={<FVSStep3 />} />
                  <Route path="/step4" element={<FVSStep4 />} />
                  <Route path="/step5" element={<FVSStep5 />} />
                  <Route path="/step6" element={<FVSStep6 />} />
                  <Route path="/step7" element={<FVSStep7 />} />
                  <Route path="/step8" element={<FVSStep8 />} />
                  <Route path="/step9" element={<FVSStep9 />} />
                  <Route path="/step10" element={<FVSStep10 />} />
                  <Route path="/step11" element={<FVSStep11 />} />
                  <Route path="/step12" element={<FVSStep12 />} />
                  <Route path="/step13" element={<FVSStep13 />} />
                  <Route path="/step14" element={<FVSStep14 />} />
                  <Route path="/step15" element={<FVSStep15 />} />
                  <Route path="/step16" element={<FVSStep16 />} />
                  <Route path="/step17" element={<FVSStep17 />} />
                  <Route path="/step18" element={<FVSStep18 />} />
                  <Route path="/step19" element={<FVSStep19 />} />
                  <Route path="/step20" element={<FVSStep20 />} />
                  <Route path="/step21" element={<FVSStep21 />} />
                  <Route path="/step22" element={<FVSStep22 />} />
                  <Route path="/step23" element={<FVSStep23 />} />
                  <Route path="/step24" element={<FVSStep24 />} />
                  <Route path="/step25" element={<FVSStep25 />} />
                  <Route path="/error" element={<FVSErrorPage />} />
                  <Route path="/" index element={<FVSStep0 formikRef={formikValuesRef} />} />
                </Routes>
                <Outlet />
                {!(location.pathname === `${PATH_FVS}/step25` || location.pathname === `${PATH_FVS}/error`) && (
                  <FormNavFooter
                    totalPages={25}
                    formNavActions={formNavActions}
                    submitPage={24}
                    submit={async () => submitForm(values)}
                    tooltips={tooltips}
                    displayErrorsCount={displayErrorsCount}
                    pageValidationKeys={FVSMetaData.pagesSegments[currentStep].validationKeys(values)}
                    formType={FormType.FAMILYVIOLENCESCHEME}
                    firstPageNo={0}
                  />
                )}
              </Form>
            )}
          </FormContainer>
        </VicFinesContext.Provider>
      )}
    </Formik>
  );
}

export default FamilyViolenceScheme;
